import React from 'react';

export const StopRecordIcon = ({height = 64, width = 64, fill = "#ff2600", ...props}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fill}
             stroke="#000000" {...props}>
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
                    stroke="#ff2600" strokeWidth="1.5"></path>
            </g>
        </svg>
    )
};